import {combineReducers} from 'redux';
//import usersReducer from './usersSlice';
import popupReducer from './popupSlice';
import userInfo from './userInfo';
import configReducer from './configSlice';
import communityStepReducer from "./communityStepSlice";

export default combineReducers({
  popupReducer,
  userInfo,
  configReducer,
  communityStepReducer
});
